/**
 * DevExtreme (esm/__internal/grids/new/grid_core/keyboard_navigation/navigation_strategy/horizontal_list.js)
 * Version: 25.1.4
 * Build date: Tue Aug 05 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import {
    NavigationStrategyBase
} from "./base";
export class NavigationStrategyHorizontalList extends NavigationStrategyBase {
    onKeyDown(event) {
        switch (event.key) {
            case "ArrowLeft":
                this.moveActiveElement(-1);
                return true;
            case "ArrowRight":
                this.moveActiveElement(1);
                return true;
            default:
                return false
        }
    }
    moveActiveElement(idxShift) {
        const currentIdx = this.activeIdx;
        if (currentIdx < 0) {
            this.focusActiveItem();
            return
        }
        const nextIdx = currentIdx + idxShift;
        this.setActiveItem(nextIdx, true)
    }
}
